import React from 'react'
import Sketch from 'react-p5'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"un",
        description:"the random sequence of u and n results in a jumpy image. somewhere it seems is always another hidden n."
    },
    de: {
        title:"un",
        description:"die zufällige anordnung der buchstaben u und n ergibt ein springendes schriftbild. irgendwo scheint immer noch ein n versteckt zu sein."
    }
});

class Un extends React.Component {
    constructor(props) {
        super(props)

        this.destWidth = 40
        this.destHeight = 40
        this.font = null
        this.minFontSize = 16
        this.fontSize = 16
        this.start = true
        this.frameInterval = 120
        this.fontLoaded = false

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    nextCh(p5) {
        return (p5.random(0, 40) < 1) ? "n" : "u"
    }

    reset(p5) {
        this.fontSize = Math.max(window.innerWidth / 40, this.minFontSize)

        this.destWidth = Math.floor(window.innerWidth / this.fontSize)
        this.destHeight = Math.floor(window.innerHeight / this.fontSize)-2

        this.start = true

        p5.background(0)
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        p5.loadFont("./fonts/DejaVuSansMono.ttf", (font) => {
            this.font = font
            this.fontLoaded = true
        });

        this.reset(p5)
    }

    drawTextMatrix(p5, xp, yp) {
        p5.textSize(this.fontSize)
        for (var y = 0; y < this.destHeight; y++) {
            for (var x = 0; x < this.destWidth; x++) {
                var ch = this.nextCh(p5)

                p5.text(ch, xp+x*this.fontSize, yp+y*this.fontSize)
            }
        }
    }

    draw(p5) {
        if (this.fontLoaded) {
            if (this.start || p5.frameCount % this.frameInterval === 0) {
                p5.textFont(this.font);
                p5.textSize(this.fontSize)
                p5.background(0)
                p5.fill(255)
                this.drawTextMatrix(p5, (window.innerWidth-this.destWidth*this.fontSize)/2, 70)
                this.start = false
            }
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} preload={this.preload} windowResized={this.windowResized} />
    }
}
Un.contextType = LanguageContext

export default Un
